<template>
  <ion-page>
    <ion-header mode="ios" v-if="showPageHeader">
      <ion-toolbar>
        <!-- <ion-icon name="chevron-back-outline"></ion-icon> -->
        <ion-buttons mode="ios" slot="start">
          <ion-back-button color="dark" mode="ios" :default-href="pageDefaultBackLink" text></ion-back-button>
        </ion-buttons>
        <ion-title class="f-center">{{pageTitle}}</ion-title>
        <ion-buttons slot="end">
          <slot name="actions-end"></slot>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <slot />
    </ion-content>

    <ion-footer v-if="showFooter">
      <!-- <ion-toolbar> -->
      <slot name="footer"></slot>
      <!-- </ion-toolbar> -->
    </ion-footer>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonBackButton,
  IonButtons,
} from '@ionic/vue'
import { ref } from 'vue'

export default {
  // props: ["pageTitle", 'show', "pageDefaultBackLink"],
  props: {
    pageTitle: {
      type: String,
    },
    pageDefaultBackLink: {
      type: String,
    },
    showFooter: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const showPageHeader = false
    // const showPageHeader = ref(window.showPageHeader)
    // const isWebview = ref(window.isWebview)
    return { showPageHeader }
  },
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonBackButton,
    IonButtons,
  },
}
</script>